import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OnlineCasinoSolutionComponent} from './online-casino-solution.component';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [OnlineCasinoSolutionComponent],
  exports: [OnlineCasinoSolutionComponent]
})
export class OnlineCasinoSolutionModule {
}



// WEBPACK FOOTER //
// ./src/app/components/online-casino-solution/online-casino-solution.module.ts